module.exports = __webpack_public_path__ + "assets/img/lens.68014ee8.svg";